// eslint-disable-next-line @typescript-eslint/naming-convention
import jwt_decode from 'jwt-decode';
export var TokenLinkType = /*#__PURE__*/ function(TokenLinkType) {
    TokenLinkType["AccountSignUp"] = "ACCOUNT_SIGNUP";
    TokenLinkType["AccountForgot"] = "ACCOUNT_FORGOT";
    TokenLinkType["AccountInvitation"] = "ACCOUNT_INVITATION";
    TokenLinkType["ForgotPassword"] = "FORGOT_PASSWORD";
    return TokenLinkType;
}({});
export var PermissionType = /*#__PURE__*/ function(PermissionType) {
    PermissionType["UserOtp"] = "USER:OTP";
    return PermissionType;
}({});
const getDecodedValue = (token)=>{
    try {
        return jwt_decode(token);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
        return null;
    }
};
export const getTokenMeta = (token)=>{
    const decoded = getDecodedValue(token);
    const isExpired = decoded ? new Date((decoded === null || decoded === void 0 ? void 0 : decoded.exp) * 1000) < new Date() : false;
    return {
        decoded,
        isExpired
    };
};
